// extracted by mini-css-extract-plugin
module.exports = {"img":"EventPlugImage_img__VHjxO"};